import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { CustomRedirect } from '@/components/navigation';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { logout } from '@/state/global/creators';
import { withRouter, RouteComponentProps } from 'react-router';
import { useQueryString } from '@/utils/hooks';
import { ensureSafeReturnUrl } from '@/utils/url';
import { resetConnections } from '@/server-events/connections';

const mapStateToProps = (state) => ({
    user: state.global.user,
});

const mapDispatchToProps = (dispatch) => ({
    logout: () => logout(dispatch),
});

type OwnProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps<any> & {};

const Logout: React.FC<OwnProps> = ({ logout, user, location }) => {
    useEffect(() => {
        logout();
        resetConnections();
    });

    const { returnUrl } = useQueryString(location);

    if (!user || user.isLoggedIn) {
        return <LoadingIndicator />;
    }

    return <CustomRedirect to={ensureSafeReturnUrl(returnUrl) || '/login'} push={false} />;
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Logout));
